import { Languages } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export function LangToggle({ className = "" }) {
  const { lang, toggle } = useLang();
  return (
    <button onClick={toggle} data-testid="language-toggle"
      className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-semibold hover:bg-muted transition-colors ${className}`}
      aria-label="Cambiar idioma / Change language">
      <Languages size={16} />
      <span data-testid="language-current">{lang === "es" ? "ES" : "EN"}</span>
    </button>
  );
}
